const BrocolyLink = ({ children }) => {
  return (
    <a href="https://app.brocoly.ar/home" target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};

export default BrocolyLink;
